import deriveBackendErrorMessage from '@dyl/utils/deriveBackendErrorMessage';
import axios from 'axios';
import merge from 'lodash/merge';
import Auth from '@aws-amplify/auth';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
    responseType: 'json',
});

api.interceptors.request.use(async config => {
        // Get the updated token from Cognito before each request
        const authSession = await Auth.currentSession();
        let token = authSession?.accessToken?.jwtToken
        let idToken = authSession?.idToken?.jwtToken

        return merge(config, {
        headers: {
            Authorization: token,
            'X-Id-Token': idToken
        },

        // Use China backend if `useChinaUrl` is set
        baseURL: (
            config.useChinaUrl ? process.env.REACT_APP_API_URL_CN || 'http://localhost:5001'
            : config.baseURL
        )
    });
});

// If possible, log the JSON response of errors to the console.
api.interceptors.response.use(undefined, function onRejected(error) {
    const response = error?.response?.data;

    if (response) {
        console.error(deriveBackendErrorMessage(error), response);
    }

    throw error;
});

export default api;